var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipToLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "skip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0506\\u66F4\\u65B0-\\u6682\\u505C/\\u64AD\\u653E/\\u8DF3\\u8F6C\\u76F4\\u64AD",
    transform: "translate(-749.000000, -149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-28\\u5907\\u4EFD-2",
    transform: "translate(646.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-22",
    transform: "translate(16.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6\\u5907\\u4EFD",
    transform: "translate(83.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "podcasts_black_24dp",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,12 C14,12.74 13.6,13.38 13,13.72 L13,22 L11,22 L11,13.72 C10.4,13.37 10,12.74 10,12 C10,10.9 10.9,10 12,10 C13.1,10 14,10.9 14,12 Z M12,6 C8.69,6 6,8.69 6,12 C6,13.74 6.75,15.31 7.94,16.4 L9.36,14.98 C8.53,14.25 8,13.19 8,12 C8,9.79 9.79,8 12,8 C14.21,8 16,9.79 16,12 C16,13.19 15.47,14.25 14.64,14.98 L16.06,16.4 C17.25,15.31 18,13.74 18,12 C18,8.69 15.31,6 12,6 Z M12,2 C6.48,2 2,6.48 2,12 C2,14.85 3.2,17.41 5.11,19.24 L6.53,17.82 C4.98,16.36 4,14.29 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,14.29 19.02,16.36 17.47,17.82 L18.89,19.24 C20.8,17.41 22,14.85 22,12 C22,6.48 17.52,2 12,2 Z",
    id: "\\u5F62\\u72B6",
    fill: "#B9B4FE",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipToLive);
export default __webpack_public_path__ + "static/media/skip_to_live.81d80738191abf850ed37f44973e3487.svg";
export { ForwardRef as ReactComponent };